/** @jsxImportSource @emotion/react */
import { useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { accessAPI, useEstetica } from "../../shared";
import { Formulario } from "../../shared";
import logoVerticalBlanco from "../../images/logoVerticalBlanco.png";
import { Boton } from "../../shared";

import { Toast } from "primereact/toast";
import { Card } from "primereact/card";
export default function CambioPassword() {
  const estetica = useEstetica();
  const [loginFormLoader, setLoginFormLoader] = useState(false);
  const [passwordActualizado, setPasswordActualizado] = useState(false);

  const navigate = useNavigate();
  const toast = useRef(null);
  const { token } = useParams("token");

  // Configuración del formulario de cambio de contraseña
  const cambioContraConfig = {
    secciones: [
      {
        campos: [
          {
            nombre: "password",
            tipoitemformularioid: 3,
            etiqueta: "Nueva contraseña",
            requerido: true
          },
          {
            nombre: "passwordrepeat",
            tipoitemformularioid: 3,
            etiqueta: "Confirmar contraseña",
            requerido: true
          }
        ]
      }
    ],
    botones: [
      {
        etiqueta: "Cambiar contraseña",
        callback: cambiarContra,
        validar: true
      },
      {
        etiqueta: "Cancelar",
        transparente: true,
        callback: () => {
          navigate("/");
        },
        confirmacion: "¿Seguro? No se actualizará la contraseña."
      }
    ]
  };

  //Cambio de contraseña y redirección a login
  function cambiarContra(contenidoCampos) {
    if (contenidoCampos) setLoginFormLoader(true);
    accessAPI(
      "PUT",
      `recuperarPassword/${token}`,
      contenidoCampos,
      (response) => {
        setLoginFormLoader(false);
        setPasswordActualizado(true);
      },
      (response) => {
        setLoginFormLoader(false);
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail:
            response[0]?.msg ||
            "Ocurrió un error, intente nuevamente más tarde.",
          sticky: true
        });
      }
    );
  }

  return (
    <main
      css={{
        paddingBottom: "50px",
        minHeight: "calc(100vh - var(--alturaFooter))"
      }}
    >
      <Toast ref={toast} position="top-center" />
      <div
        css={{
          paddingTop: "50px",
          marginBottom: "30px",
          width: "100%",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        <img
          css={{
            width: "150px",
            marginLeft: "auto",
            marginRight: "auto",
            display: "block"
          }}
          // El logo en blanco del organismo; si no cargó uno, el de la
          // plataforma.
          src={estetica?.logos?.blanco || logoVerticalBlanco}
          alt="logo"
        />
      </div>
      <Card
        css={{
          width: "400px",
          marginLeft: "auto",
          marginRight: "auto"
        }}
      >
        {!passwordActualizado ? (
          <div>
            <h1>Cree una contraseña nueva</h1>
            <p>
              Una vez configurada podrá utilizarla para ingresar al sistema.
            </p>
            <Formulario
              config={cambioContraConfig}
              loader={loginFormLoader}
              formularioEnCuerpo
            />
          </div>
        ) : (
          <div css={{ textAlign: "center" }}>
            <h1>Contraseña actualizada correctamente.</h1>
            <p>Vuelva al login e ingrese con su nueva contraseña</p>
            <Boton callback={() => navigate("/")} transparente>
              Volver al login
            </Boton>
          </div>
        )}
      </Card>
    </main>
  );
}
